import { RequestServerClass } from '@/util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam'; // post请求体转换方法

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

export class GetArea {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 根据code获取区
  public getArea() {
    const url = serverUrl + '/api/sysManage/administrativeDivision/area/510100';
    return this.rSerivce.serverObj.get(url);
  }

  public getStreet(code: any) {
    const url = serverUrl + '/api/sysManage/administrativeDivision/street/' + code;
    return this.rSerivce.serverObj.get(url);
  }
  public getAreaDept(code: any) {
    const url = serverUrl + '/api/spaceManage/spaceAreaDept/all?bsAreaCode=' + code;
    return this.rSerivce.serverObj.get(url);
  }
}
